export default class SourceVirtualLine {
  constructor(config) {
    this.id = config.id;
    this.name = config.name;
    this.originalAdvertiserCampaignId = config.originalAdvertiserCampaignId;
    this.originalAffiliateCampaignId = config.originalAffiliateCampaignId;
    this.isRingpool = config.isRingpool;
    this.isCallPromotion = config.isCallPromotion;
    this.isSyndicated = config.isSyndicated;
    this.errorMessages = [];
  }

  validate(campaignIds) {
    this.errorMessages = [].concat(
      this.destinationNotSameAsSource(campaignIds),
      this.isValidNumberType()
    ).filter(error => error);
  }

  destinationNotSameAsSource(campaignIds) {
    const errorMessage = "Destination cannot be the same as the Promo Number's current campaign";

    if (this.originalAdvertiserCampaignId === campaignIds.advertiserCampaignId && !this.isCallPromotion) {
      if (this.originalAffiliateCampaignId) {
        if (this.originalAffiliateCampaignId === campaignIds.affiliateCampaignId) {
          return errorMessage;
        }
      } else {
        return errorMessage;
      }
    }
  }

  isValidNumberType() {
    const errors = [];

    if (this.isRingpool) {
      errors.push("Ringpool");
    }

    if (this.isCallPromotion) {
      errors.push("Call Promotion");
    }

    if (this.isSyndicated) {
      errors.push("Syndicated");
    }

    return errors;
  }

  lineItemErrors() {
    if (this.errorMessages.length > 0) {
      const formattedErrors = this.errorMessages.join(", ");
      return `${this.name} ${formattedErrors}`;
    }
  }
}
